import React, { useState } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Tooltip } from 'primereact/tooltip';
import { PrimeIcons } from 'primereact/api';
import securecode from '../assets/securecode.png';

const PayrollReporting = () => {
  const [isImageModalActive, setImageModalActive] = useState(false);

  return (
    <div style={{ marginTop: 40, display: 'flex', justifyContent: 'center' }}>
      <Card style={{ width: '800px' }}>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ color: '#004771' }}>Payroll Reporting</h1>
          <h2 style={{ color: '#4a4a4a', fontSize: '1.25rem', marginTop: '-1.25rem' }}>The easiest way to report payroll is online.</h2>
        </div>
        <div style={{ margin: '2rem 0' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ flex: 1, textAlign: 'center' }}>
              <h5 style={{ fontWeight: 600, fontSize: '1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                Secure Code Login&nbsp;
                <span
                  style={{ cursor: 'pointer', color: '#2196F3', display: 'inline-flex', alignItems: 'center', fontSize: '1em' }}
                  data-pr-tooltip="Click for help"
                  onClick={() => setImageModalActive(true)}
                >
                  <i className={PrimeIcons.QUESTION_CIRCLE} style={{ fontSize: '1em' }} />
                </span>
                <Tooltip target="[data-pr-tooltip]" />
              </h5>
              <div style={{ fontSize: 13, marginBottom: 16 }}>
                Use the secure code from the payroll report form to access online reporting.<br /><br />
              </div>
              <Button label="Continue with Secure Code" icon="pi pi-lock-open" className="p-button-warning" size="small" onClick={() => window.location.href = '/reportpayroll'} style={{ marginBottom: 8 }} />
              <div>
                <a href="/ph/registration/#/">&nbsp;</a>
              </div>
            </div>
            <div style={{ width: 2, background: '#eee', height: 120, margin: '0 24px' }} />
            <div style={{ flex: 1, textAlign: 'center' }}>
              <h5 style={{ fontWeight: 600, fontSize: '1.25rem' }}>Republic Website Login</h5>
              <div style={{ fontSize: 13, marginBottom: 16 }}>
                Existing users login to your account to access online reporting and other policy information. Click Register to create a new account.
              </div>
              <Button label="Policyholders Login" icon="pi pi-lock" className="p-button-warning" size="small" onClick={() => window.location.href = '/account-management'} style={{ marginBottom: 8 }} />
              <div>
                <a href="/ph/registration/#/">Register</a>
              </div>
            </div>
          </div>
        </div>
        <div style={{ textAlign: 'center', fontSize: '0.875rem', margin: '2rem 0' }}>
          <b>If you have questions or need assistance with reporting, contact your audit representative:</b>
          <br /><br />
          Phone: 800-662-1485 Option 3.<br />
          Email: <a href="mailto:riaudit@ri-net.com">riaudit@ri-net.com</a>
          <br /><br />
          <b>If you are enrolled in Pay-As-You-Go, you can login <a href="https://republicindemnity.payrollpl.us/">here</a> to report your payroll.</b>
        </div>
        <Dialog header="Secure Code Help" visible={isImageModalActive} style={{ width: '50vw' }} onHide={() => setImageModalActive(false)}>
          <img src={securecode} alt="Secure Code Help" style={{ width: '100%' }} />
        </Dialog>
      </Card>
    </div>
  );
};

export default PayrollReporting;
